import { JsonForms } from "@jsonforms/react";
import ButtonComponent from "../button/Button"
import { materialCells, materialRenderers } from "@jsonforms/material-renderers";
import { CustomArraySelectTester, CustomDateInputTester, CustomFileUploadTester, CustomMultiSelectTester, CustomNumberTextInputTester, CustomSelectTester, CustomTextAreaTester, CustomTextInputTester, CustomArray2SelectTester, CustomAdventureArrayTester } from "../JsonForm/CustomInputTester";
import {
  CustomTextInputRenderer,
  CustomMultipleSelectInputRenderer,
  CustomSelectInputRenderer,
  CustomNumberTextInputRenderer,
  CustomTextAreaInputRenderer,
  CustomArraySelectRenderer,
  CustomDateInputRenderer,
  CustomFileUploadRenderer,
  CustomArray2SelectRenderer,
  CustomAdventureArrayRendererControl
} from "../JsonForm/CustomInputRenderer";
import { useEffect, useState } from "react";

const AddForm = ({title, subtitle, uischema, schema, initialData={}, close, handleSubmit, actionName="Add"}) => {
  const [data, setData] = useState({});
  const [intData, setIntData] = useState({});
  const onChange = (e) => {
    // console.log("JsonForms change event:", e.data); // Log what JsonForms gives directly
    setData(e.data); // Directly set the data from JsonForms
  };

  useEffect(() => {
    // Make sure initialData is applied correctly when component mounts
    setData(initialData);
  }, [initialData]); // Depend on initialData to re-run if it changes externally

  const onSubmit = async () => {
    // This 'data' state should now hold the correctly structured data
    console.log("Submitting data:", data);
    await handleSubmit(data, close);
  };

  console.log("Current form data state:", data);

  return (
    <div className="px-10 py-5">
      {/* TOP */}
      <div className="border-b-2 border-color-primary-dark2 pb-3 my-5">
        <div className="font-bold uppercase">{title}</div>
        <div>{subtitle}</div>
      </div>
      {/* CONTENT */}
      <div>
        <JsonForms
          schema={schema}
          uischema={uischema}
          data={data}
          renderers={[
            ...materialRenderers,
            {
              tester: CustomNumberTextInputTester,
              renderer: CustomNumberTextInputRenderer,
            },
            {
              tester: CustomTextInputTester,
              renderer: CustomTextInputRenderer,
            },

            {
              tester: CustomSelectTester,
              renderer: CustomSelectInputRenderer,
            },
            {
              tester: CustomMultiSelectTester,
              renderer: CustomMultipleSelectInputRenderer,
            },
            {
              tester: CustomTextAreaTester,
              renderer: CustomTextAreaInputRenderer,
            },
            {
              tester: CustomArraySelectTester,
              renderer: CustomArraySelectRenderer,
            },
            {
              tester: CustomDateInputTester,
              renderer: CustomDateInputRenderer,
            },
            {
              tester: CustomFileUploadTester,
              renderer: CustomFileUploadRenderer,
            },
            {
              tester: CustomArray2SelectTester,
              renderer: CustomArray2SelectRenderer,
            },
            {
              tester: CustomAdventureArrayTester,
              renderer: CustomAdventureArrayRendererControl,
            },
            // Add more custom renderers here
          ]}
          cells={materialCells}
          onChange={onChange}
        />
      </div>
      <div className="border-t-2 border-color-primary-dark2 pt-3 my-5 flex space-x-3">
        <div onClick={close}>
          <ButtonComponent type={"cancel"} name={"Cancel"} />
        </div>
        <div onClick={onSubmit}>
          <ButtonComponent type={"add"} name={actionName} />
        </div>
      </div>
    </div>
  );
}

export default AddForm